<!-----专家不参加抽取时间设置 --->
<template>
  <div class="display"
       v-if="expertIn">
    不参加抽取时间区间：
    <span v-if="isOpen">
      <a-date-picker v-model="startValue"
                     :disabled-date="disabledStartDate"
                     show-time
                     :format="dateFormatStr"
                     placeholder="开始时间"
                     @openChange="handleStartOpenChange" />
      <a-date-picker class="ml-2"
                     v-model="endValue"
                     :disabled-date="disabledEndDate"
                     show-time
                     :format="dateFormatStr"
                     placeholder="结束时间"
                     :open="endOpen"
                     @openChange="handleEndOpenChange" />
    </span>
    <span v-else>
      <span v-if="formData.notExtractStartTime">{{ formData.notExtractStartTime }} ~ {{ formData.notExtractEndTime }}</span>
      <span v-else>暂不设置</span>
    </span>
    <div class="ml-2">
      <a-button type="primary"
                @click="onSetExpertNotExtractTime"
                v-if="!isOpen">
        设置
      </a-button>
      <span v-else>
        <a-button type="primary"
                  @click="onSaveSetExpertNotExtractTime"> 确认 </a-button>
        <a-button @click="onclear"
                  class="ml-2"> 清空并关闭 </a-button>
      </span>
    </div>
    <span style="color:red;"
          class="ml-5"
          v-if="isOpen">注：开始时间和结束时间为空则不设置</span>
  </div>
</template>

<script>
import {
  ExpertSetNotExtractTime,
  GetExpertByUserId,
} from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import moment from 'moment'
export default {
  name: 'SetNotExtractTimeForm',
  data () {
    return {
      dateFormatStr: 'YYYY-MM-DD HH:mm',
      formData: {
        expertId: '',
        notExtractStartTime: '',
        notExtractEndTime: '',
      },
      startValue: null,
      endValue: null,
      endOpen: false,
      isOpen: false,
      expertIn: false
    }
  },
  created () {
    this.initGetData()
  },
  methods: {
    initGetData () {
      GetExpertByUserId().then((res) => {
        if (res.code == 200) {
          const result = res.result
          if (result) {
            this.expertIn = true
          } else {
            this.expertIn = false
            return
          }
          this.formData = {
            expertId: result.id,
            notExtractStartTime: result.notExtractStartTime,
            notExtractEndTime: result.notExtractEndTime,
          }
          if (result.notExtractStartTime != null) {
            this.startValue = moment(result.notExtractStartTime)
            this.endValue = moment(result.notExtractEndTime)
          }
        }
      })
    },
    onSetExpertNotExtractTime () {
      this.isOpen = true
    },
    async onSaveSetExpertNotExtractTime () {
      if (this.startValue) {
        this.formData.notExtractStartTime = moment(this.startValue).format(
          this.dateFormatStr
        )
      } else {
        this.formData.notExtractStartTime = null
      }
      if (this.endValue) {
        this.formData.notExtractEndTime = moment(this.endValue).format(this.dateFormatStr)
      } else {
        this.formData.notExtractEndTime = null
      }
      const res = await ExpertSetNotExtractTime(this.formData)
      if (res.code == 200) {
        this.$message.success('设置成功')
        this.isOpen = false
      } else {
        this.$message.error(res.message)
      }
    },
    disabledStartDate (startValue) {
      const endValue = this.endValue
      if (!startValue || !endValue) {
        return false
      }
      return startValue.valueOf() > endValue.valueOf()
    },
    disabledEndDate (endValue) {
      const startValue = this.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange (open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange (open) {
      this.endOpen = open
    },
    onclear () {
      this.startValue = null
      this.endValue = null
      this.isOpen = false
    }
  },
};
</script>

<style lang="less" scoped>
.display {
  background: white;
  padding: 10px;
  display: flex;
  align-items: center;
  font-weight: bold;
}
</style>
